import { mutationOptions } from "@tanstack/react-query";
import { createServerFn } from "@tanstack/react-start";
import { eq } from "drizzle-orm";
import z from "zod";

import { requirePermissions } from "@/auth/shared";
import { db } from "@/db/connection";
import { tournamentInviteSources } from "@/db/schema";

const bulkUpsertInviteSourcesSchema = z.object({
  sourceTournamentDivisionIds: z.array(z.number()).min(1),
  targetTournamentId: z.number(),
  topN: z.number().min(1),
});

export const bulkUpsertInviteSourcesFn = createServerFn({ method: "POST" })
  .middleware([requirePermissions({ tournaments: ["update"] })])
  .inputValidator(bulkUpsertInviteSourcesSchema)
  .handler(
    async ({
      data: { sourceTournamentDivisionIds, targetTournamentId, topN },
    }) => {
      await db
        .insert(tournamentInviteSources)
        .values(
          sourceTournamentDivisionIds.map((sourceTournamentDivisionId) => ({
            sourceTournamentDivisionId,
            targetTournamentId,
            topN,
          })),
        )
        .onConflictDoUpdate({
          target: [
            tournamentInviteSources.sourceTournamentDivisionId,
            tournamentInviteSources.targetTournamentId,
          ],
          set: { topN },
          where: eq(tournamentInviteSources.processed, false),
        });

      return { success: true };
    },
  );

export const bulkUpsertInviteSourcesMutationOptions = () =>
  mutationOptions({
    mutationFn: (data: z.infer<typeof bulkUpsertInviteSourcesSchema>) =>
      bulkUpsertInviteSourcesFn({ data }),
  });
